// form
import { useFormContext, Controller } from 'react-hook-form';
// @mui
import { TextField, TextFieldProps } from '@mui/material';

// ----------------------------------------------------------------------

type IProps = {
  name: string;
  type?: string;
  width?: string | undefined;
  outlinedError?: boolean;
};

type Props = IProps & TextFieldProps;

export default function RHFTextField({ name, type, width, outlinedError, size, ...other }: Props) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (<>
          <TextField
            {...field}
            size={size || 'small'}
            type={type || 'text'}
            sx={{ width: width || '100%' }}
            value={((typeof field.value === 'number' && field.value === 0) || !field.value) ? '' : field.value}
            error={!!error}
            label={ outlinedError && error?.message }
            helperText={ !outlinedError && error?.message}
            inputProps={{
              autoComplete: 'off',
            }}
            FormHelperTextProps={{ style: { marginLeft: 0 } }}
            {...other}
          />
        </>)}
    />
  );
}
